import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 


const FullPageLoader = () => (
  <div style={{
      display: 'flex',
      flexDirection: 'column', 
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh', 
      width: '100vw', 
      position: 'fixed', 
      top: 0,
      left: 0,
      backgroundColor: 'rgba(255, 255, 255, 0.8)', 
      zIndex: 9999, 
      fontFamily: 'sans-serif' 
     }}>
    {/* Simple CSS Spinner */}
    <div className="spinner" style={{
         border: '5px solidrgb(211, 118, 12)', 
         borderTop: '5px solidrgb(205, 219, 52)', 
         borderRadius: '50%',
         width: '50px',
         height: '50px',
         animation: 'spin 1s linear infinite'
        }}>
    </div>
    <p style={{ marginTop: '20px', color:'orange', fontSize: '1.1em' }}>
        Directing You...
    </p>
    <style>{`
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `}</style>
  </div>
);
// -----------------------------------------

function ProtectedRoute({ children }) {
  const { isLoggedIn, loading } = useAuth(); 
  const location = useLocation();

  
  if (loading) {
    console.log("ProtectedRoute: Auth context loading...");
    return <FullPageLoader />; 
  }

  
  if (!isLoggedIn) {
    console.log(`ProtectedRoute: Not logged in. Redirecting from ${location.pathname} to /login`);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  
  console.log("ProtectedRoute: Logged in, rendering requested component.");
  return children;
}

export default ProtectedRoute;